import { render, staticRenderFns } from "./BuyerRoiPerKind.vue?vue&type=template&id=fef40754&"
import script from "./BuyerRoiPerKind.vue?vue&type=script&lang=js&"
export * from "./BuyerRoiPerKind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports